import React, { useCallback, useState } from 'react';
import cn from 'classnames';

import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';

import AssetClassesContainer from './common/AssetClasses';
import BondsSidebarContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/BondsSidebarContainer';
import ProductPageHeader from '@/creditflowresearch/ui/common/components/templates/ProductPageHeader/ProductPageHeader';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import {
  BONDS_PAGE_TITLE,
  bondsImageCaption,
  bondsNoAccessDescription,
  bondsNoAccessFeatures,
} from '@/creditflowresearch/ui/components/bonds/constants';
import BondsPageContent from '@/creditflowresearch/ui/components/bonds/BondsPageContent';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import image from '@/creditflowresearch/ui/assets/noAccess/bondsNoAccess.webp';

import styles from './bonds.module.scss';
import pageStyles from '@framework/global-styles/page.module.scss';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import productColors from '@/creditflowresearch/ui/common/styles/productColors';

const Bonds = () => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const { checkAccessByUserPlan } = useUserPlanContext();
  const { checkAccessByUserRegions, checkAccessByUserProducts } = usePageFiltersContext();
  const checks = [
    checkAccessByUserPlan(UserPlanType.PRO),
    checkAccessByUserRegions(),
    checkAccessByUserProducts(),
  ];

  const toggleSidebar = useCallback(() => setSidebarIsOpen((prevIsOpen) => !prevIsOpen), []);

  return (
    <>
      <div className={ styles.bondsLayout }>
        <>
          <ProductPageHeader
            title="BWICS & Inventory"
            withoutProductTitle
            accessConditions={ [{ checks }] }
            blockingAccessConditions={ [{ checks: [checkAccessByUserPlan(UserPlanType.STARTER)] }] }
            panelBackground={ productColors.gradientProductAbs }
          />
          <div className={ styles.pageNavigation }>
            <CheckUserAccess
              conditions={ [{
                checks,
                fallback: (
                  <div className={ cn(pageStyles.pageNavigationLinks, spacesStyles.pbl, styles.mobileHide) }>
                    <AssetClassesContainer />
                  </div>
                ),
              }] }
            >
              <div className={ cn(pageStyles.pageNavigationLinks, spacesStyles.pbl) }>
                <AssetClassesContainer />
              </div>
            </CheckUserAccess>
          </div>
          <CheckUserAccess
            conditions={ [{
              checks,
              fallback: (
                <NoAccessOverlay
                  title={ BONDS_PAGE_TITLE }
                  features={ bondsNoAccessFeatures }
                  description={ bondsNoAccessDescription }
                  imageCaption={ bondsImageCaption }
                  image={ image.src }
                />
              ),
            }] }
          >
            <>
              <BondsPageContent onFiltersToggle={ toggleSidebar } />
              <BondsSidebarContainer
                isOpen={ sidebarIsOpen }
                onSidebarToggle={ toggleSidebar }
              />
            </>
          </CheckUserAccess>
        </>
      </div>
      <MissingSomethingModalButton className={ cn(spacesStyles.ptxl, spacesStyles.pbxl) } />
    </>
  );
};

export default Bonds;
